export default function({ res }) {
  if (res) {
    res.setHeader('Cache-Control', 'no-cache');
    //res.setHeader('Strict-Transport-Security', 'max-age=63072000; includeSubDomains;');

    // if (process.env.STORE_VERSION) {
    //   res.setHeader('ETag', process.env.STORE_VERSION);
    // }
  }
}
